import { IJF_KATA_EVALUATION_SOURCE } from '../../data/scoring/source'
import { useI18n } from '../../i18n'
import styles from '../../routes/KataScoring.module.css'

const CRITERIA_NOTIFY_EMAIL = 'developers@the-fortitudes.com'

/** Prominent citation of the exact IJF criteria document version. */
export function ScoringCriteriaSourceNotice() {
  const { t } = useI18n()
  const notifyMailto = `mailto:${CRITERIA_NOTIFY_EMAIL}?subject=${encodeURIComponent(
    t('scoring.criteriaNotifySubject'),
  )}&body=${encodeURIComponent(
    t('scoring.criteriaNotifyBody', {
      title: IJF_KATA_EVALUATION_SOURCE.title,
      url: IJF_KATA_EVALUATION_SOURCE.url,
    }),
  )}`

  return (
    <div className={styles.criteriaSourceNotice} role="note">
      <span className={styles.criteriaSourceLabel}>
        {t('scoring.criteriaSourceLabel')}
      </span>
      <a
        className={styles.criteriaSourceLink}
        href={IJF_KATA_EVALUATION_SOURCE.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {IJF_KATA_EVALUATION_SOURCE.title}
        <span className="sr-only"> {t('common.opensNewTab')}</span>
      </a>
      <a className={`btn btn-secondary ${styles.criteriaNotifyBtn}`} href={notifyMailto}>
        {t('scoring.criteriaNotifyCta')}
      </a>
    </div>
  )
}

/** Footer practice-aid attribution. */
export function ScoringDisclaimer() {
  const { t } = useI18n()

  return <p className={styles.disclaimer}>{t('scoring.disclaimer')}</p>
}
